// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import dataTableStyles from "@awc/App/SharedStyles/MyAccountPages/List/DataTableStyles";
import { productListStyles } from "@awc/Overrides/Widgets/MyListsDetails/MyListsDetailsProductList";
import { color, xScreen } from "@awc/XDL/Utilities";
import translate from "@insite/client-framework/Translate";
import Move from "@insite/mobius/Icons/Move";
import { css } from "styled-components";

productListStyles.centeringWrapper = {
    ...dataTableStyles.centeringWrapper,
};

productListStyles.messageText = {
    ...dataTableStyles.noResultsText,
};

productListStyles.sortOrderWrapper = {
    css: css`
        position: absolute;
        top: 50%;
        left: 0;
        z-index: 1;
        transform: translate(0, -50%);
        @media print {
            display: none;
        }
        ${xScreen("lte", "sm")} {
            margin: 0;
            top: 12px;
            left: 37px;
            transform: translate(-50%, 0);
        }
    `,
};

productListStyles.dragHandleIcon = {
    src: Move,
    size: 13,
    css: css`
        cursor: move;
        margin: 0 12px;
        ${xScreen("lte", "sm")} {
            margin: 0;
        }
    `,
};

productListStyles.lineGridItem = {
    width: 12,
    css: css`
        position: relative;
    `,
};

productListStyles.container = {};

productListStyles.notesTextArea = {
    placeholder: translate("Notes"),
};

productListStyles.titleWrapper = {
    css: css`
        background-color: ${color("common.ui17")};
        padding: 15px 20px;
    `,
};

productListStyles.titleText = {
    size: 20,
};
